import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { actions } from '../constants/postcode_light_box/actions';

class PostcodeLightBoxStoreClass extends ReduceStore {
    getInitialState() {
        return {
            visible: false,
            showError: false,
        };
    }

    reduce(state, { source, action }) {
        if (source === ACTION_TYPES.POSTCODE_LIGHT_BOX_ACTION) {
            switch (action.type) {
            case actions.SHOW:
                if (!state.visible) {
                    state.visible = true;
                    this.__emitChange();
                }
                break;

            case actions.HIDE:
                if (state.visible) {
                    state.visible = false;
                    this.__emitChange();
                }
                break;
            case actions.SHOW_ERROR:
                if (!state.showError) {
                    state.showError = true;
                    this.__emitChange();
                }
                break;
            case actions.HIDE_ERROR:
                if (state.showError) {
                    state.showError = false;
                    this.__emitChange();
                }
                break;
            }
        }

        return state;
    }
}

export const PostcodeLightBoxStore = new PostcodeLightBoxStoreClass(Dispatcher);
